import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import axios from "axios";


import Spinner from '../../spinners/DataSpinner';

const ViewOrders = () => {

    const [loading, setLoading] = useState(true);
    const [orderList, setOrderList] = useState([]);

    useEffect(() => {
        let isMounted = true;
        document.title = "Orders";
        axios.get(`api/orders`).then(res => {
            if (isMounted) {
                if (res.data.status === 200) {
                    setOrderList(res.data.orders);
                };
                setLoading(false);
            }
        });

        return () => {
            isMounted = false;
        }

    }, []);


    let dataTableData = '';
    if (loading) {
        return <Spinner />
    } else {
        dataTableData =
            orderList.map((item) => {
                return (
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.tracking_no}</td>
                        <td>{item.phone}</td>
                        <td>{item.email}</td>
                        <td>
                            <Link className="btn btn-success btn-sm">View</Link>
                        </td>
                    </tr>
                );
            });
    }

    return (
        <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h3 className="h5 mb-0 text-gray-800">Orders</h3>
            </div>
            <div className="card-body">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Trucking No</th>
                            <th scope="col">Phone No</th>
                            <th scope="col">Email</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataTableData}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ViewOrders;